export default {
  props: {
    /**
     * The field name.
     */
    name: {
      type: String,
      required: true,
    },

    /**
     * The field value.
     */
    value: {
      type: [String, Number],
      required: false,
      default: '',
    },

    /**
     * The base key to translate the form.
     */
    translation: {
      type: String,
      required: false,
    },

    /**
     * If the input has label.
     */
    hasLabel: {
      type: Boolean,
      required: false,
    },

    /**
     * If the input has error.
     */
    error: {
      type: String,
      required: false,
    },

    /**
     * If the input has error.
     */
    insideForm: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * If the input is disabled.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    /**
     * This method will be called when input event is fired.
     *
     * @param  {String} name    The field name.
     */
    onInput(name) {
      return (value) => {
        this.$emit('keydown', name, value);
      };
    },

    toFloat(number) {
      return parseFloat(number.replace(/\s/g, '').replace(/,(\d+)$/, '.$1'));
    },

    formatOnDecimalInput(e) {
      const name = e.target.name;
      const value = e.target.value.toString();

      const newValue = value.replace(/[^-?0-9,.]/g, '');
      const count = (newValue.match(/,/g) || []).length;

      let finalValue = newValue;
      for (let i = 0; i < count - 1; i += 1) {
        finalValue = finalValue.replace(/,/, '');
      }

      e.target.value = finalValue;
      this.$emit('keydown', name, finalValue.replace(/,/g, '.'));
    },
  },

  /**
   * This function will be called to render the HTML.
   *
   * @param  {Function} h    Mandatory for vue to render JSX.
   */
  // eslint-disable-next-line
  render (h) {
    this.$emit('keydown', this.name, this.value.toString().replace(/,/g, '.'));
    const input = <div
      style={{ width: '100%' }}
      onKeyup={this.formatOnDecimalInput}
    >
      <el-input
        value={this.value.toString().replace(/\./g, ',')}
        disabled={this.disabled}
        type='text'
        placeholder={this.translation ? this.$t(`${this.translation}.placeholder`) : this.name}
        name={this.name}
      />
    </div>;

    if (!this.insideForm) {
      return input;
    }

    let label = null;
    if (this.hasLabel) {
      label = this.translation ? this.$t(`${this.translation}.label`) : this.name;
    }

    return (
      <el-form-item
        error={this.error}
        label={label}
      >
        {input}
      </el-form-item>
    );
  },
};



// WEBPACK FOOTER //
// ./src/app/components/form/float/float.jsx